import { useUser as useAuth0User } from '@auth0/nextjs-auth0/client';

import useIsCalmSleepApp from '../useIsCalmSleepApp';
import { getProfileRoute } from './authRoutes';

export default function useUser() {
	const isCalmSleepApp = useIsCalmSleepApp();
	return useAuth0User({ route: getProfileRoute(isCalmSleepApp) });
}
